import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Visibility as PreviewIcon } from '@mui/icons-material';
import { PdfPreviewModal } from './PdfPreviewModal';
import type { DocumentPreviewButtonProps } from '../types/pdf.types';

export function DocumentPreviewButton({ document }: DocumentPreviewButtonProps) {
  const [open, setOpen] = useState(false);

  const isPdf = document.contentType === 'application/pdf';

  if (!isPdf) {
    return null;
  }

  return (
    <>
      <Tooltip title="Vorschau">
        <IconButton size="small" onClick={() => setOpen(true)}>
          <PreviewIcon />
        </IconButton>
      </Tooltip>

      <PdfPreviewModal
        open={open}
        onClose={() => setOpen(false)}
        document={document}
      />
    </>
  );
}
